'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'tree';
var width = 512;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = ['M16 448l208 0 0-256 64 0 0 256 208 0-121.8-144 89.8 0-108.3-128 76.3 0-176-208-176 208 76.3 0-108.3 128 89.8 0-121.8 144z', 'M288 192l0 352-64 0 0-352 64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;